const INGREDIENT_PHRASE_FIELD_NAMES = {
  NEGATIVE: 'negativeSynonymPhrases',
  PAIRING: 'pairingPhrases',
  REFERENCING: 'referencingPhrases',
}

export default INGREDIENT_PHRASE_FIELD_NAMES
